var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"target":"_blank","to":{
            name: 'CascadingElements',
            params: {
              element_id: _vm.scope.row.id,
              parent_id: null,
            }
          }}},[_c('el-button',{staticClass:"table-action-button",attrs:{"round":"","icon":"fas fa-wrench"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }